<!-- Input Area -->
<div class="p-4 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800">
  <div class="relative max-w-3xl mx-auto">
    <textarea
      [(ngModel)]="input"
      (keydown)="handleKeyDown($event)"
      placeholder="Ask a question..."
      autosize
      [minRows]="1"
      [maxRows]="8"
      class="w-full border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 rounded-xl py-3 pl-4 pr-12 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
      [disabled]="isLoading">
    </textarea>
    <button
      (click)="handleSendMessage()"
      [disabled]="!input.trim() || isLoading"
      class="absolute right-2 bottom-3 bg-blue-600 text-white rounded-lg p-2 hover:bg-blue-700 disabled:bg-gray-400 dark:disabled:bg-gray-600 disabled:cursor-not-allowed transition-colors"
      title="Send message">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
      </svg>
    </button>
  </div>
</div>
